// Recovered compiled webpack factory 38561. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { K: () => n });
  function n(t, e, i) {
    if (null == t) return [];
    if (t instanceof EventTarget) return [t];
    if ("string" == typeof t) {
      let n = document;
      e && (n = e.current);
      let s = i?.[t] ?? n.querySelectorAll(t);
      return s ? Array.from(s) : [];
    }
    return Array.from(t).filter((t) => null != t);
  }
}
